export default class ASTBlock {
    constructor(color, name){
        this.TOP_LEVEL = false
        this.name = name

        this.fields = {}
        this.statements = {}
        this.values = {}
        this.next = undefined

        this.color = color

        this.includes = [name + "_includes"]
        this.declarationCode = [name + "_declaration"]
        this.functionCode = [name + "_functions"]
        this.setupCode = [name + "_setup"]
        this.loopCode = [name + "_loop"]
        this.runCode = [name + "_run"]
    }
    
    
    static addToBlockly(){

    }

    static createInstance(color){
        return new this(color)
    }
}